import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { IPublicProfilesFollowedData } from "@/data/public-profiles";
import { IFetcherRenderProps } from "@/hooks/http";
import { ClientRecord } from "@/views/Clients/List/ClientRecord";
import { InfoboxSection } from "@/views/components/Page/List/InfoboxSection";

import emptyFollowed from "./empty-followed.svg";

interface IFollowedSettingsProps extends IFetcherRenderProps<IPublicProfilesFollowedData[]> {
  onRecordUpdate: () => void;
}

export const FollowedCompaniesList: FC<IFollowedSettingsProps> = ({ onRecordUpdate, ...fetcher }) => {
  const { t } = useTranslation("session");

  if (!fetcher.payload?.length) {
    return (
      <InfoboxSection
        imgSrc={emptyFollowed}
        heading={t("USERS.SETTINGS.FOLLOWED.NO_FOLLOWED")}
        description={t("USERS.SETTINGS.FOLLOWED.NO_FOLLOWED_TEXT")}
      />
    );
  }

  return (
    <>
      {fetcher.payload?.map(client => (
        <ClientRecord key={client.id} client={client} onRecordUpdate={onRecordUpdate} />
      ))}
    </>
  );
};
